import React from 'react';
import { useParams } from 'react-router-dom';
import ResponsibleChildrensForm from '../../../../components/forms/ResponsibleChildrensForm';

export default function ResponsibleChildrensCreatePage() {
  const { parentId } = useParams();

  return <ResponsibleChildrensForm parentId={parentId} />;
}
